export const API_ROOT = "https://solsita-backend.herokuapp.com/api"
export const WEBSITE_NAME = "Soledad Muñoz"
export const TITLE_COLOUR = ""
export const MENU_COLOUR = ""
export const TEXT_COLOUR = ""
export const MOBILE_BREAKPOINT = 800